import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SpecialCharacters } from 'src/app/core/enums';
import { UnitConfigurationService } from 'src/app/core/services/common/unit-configuration/unit-configuration.service';
import { CONSTS } from './package-setting.constants';

@Component({
  selector: 'app-package-setting',
  templateUrl: './package-setting.component.html',
  styleUrl: './package-setting.component.scss',
  standalone: false,
})
export class PackageSettingComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input({ required: true }) unit!: 'I' | 'M';

  readonly CONSTANTS = CONSTS;
  readonly REGEX = SpecialCharacters.DECIMAL_NUMBER;

  constructor(private unitConfig: UnitConfigurationService) {}

  getUnit(val: string) {
    return this.unitConfig.getUnitMappingByType(this.unit)[val];
  }
}
